
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import InlineCalendar from 'vux/src/components/inline-calendar/index.vue'
import numberPad from 'vux/src/tools/number/pad.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import vuescroll from 'vuescroll'
import { mapState, mapActions } from 'vuex'
import { timestamp } from '@/assets/scripts/utils'
export default {
name: 'info',
props: [],
directives: {
TransferDom
},
components: {
XHeader,
XInput,
Group,
XButton,
Checker,
CheckerItem,
Flexbox,
FlexboxItem,
PopupHeader,
Popup,
Cell,
XSwitch,
XNumber,
InlineCalendar,
'scroller': vuescroll,
Confirm
},
data () {
return {
isEdit: this.$route.params.isEdit,
brand: '#FEAA33',
sites: [],
dateShow: false,
isTimes: '',
carItem: {
way: this.$route.params.way,
site: '',
isTransfer: false,
personNumber: 1,
stationDay: '',
stationTime: '',
schoolDay: '',
schoolTime: '',
isOnTime: false
},
carInfo: [],
timeOps: {
scrollPanel: {
scrollingY: false,
initialScrollX: 480
},
bar: {
background: 'rgba(0, 107, 178, 1)',
size: '3px',
opacity: 0
}
},
timeNum: 24,
selectTime: {
date: '',
time: '00:00',
startDate: '',
endDate: ''
},
siteCueent: '',
showConfirm: false,
sureToLeave: false,
id: '',
datamanagementId: '',
btnSavetext: '办理',
companion: ''
}
},
computed: {
...mapState({
token: state => state.token,
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId,
flowType: state => state.flowInfo.flowType,
title: state => state.currentProcedureInfo.name,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId,
endDate: state => state.currentProcedureInfo.endDate
}),
type () {
return this.$route.params.type
},
status () {
return this.$route.params.status
},
btnDisabled () {
let flag = true
if ((this.siteCueent === '' && this.type !== '4') || this.carItem.stationDay === '' || this.carItem.schoolDay === '') {
flag = true
} else {
flag = false
}
return flag
}
},
created () {},
mounted () {
this.getCarList()
},
updated () {},
destroyed () {},
watch: {},
methods: {
...mapActions(['carInfoAction']),
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},

save () {
this.$vux.loading.show({
text: '加载中,请稍后'
})
let params = {
'id': this.id,
'studentId': this.studentId,
'datamanagementId': this.datamanagementId,
'flowId': this.flowId,
'flowProcedureId': this.flowProcedureId,
'procedureId': this.procedureId,
'transportation': this.type,
'departureDatetime': this.carItem.stationDay + ' ' + this.carItem.stationTime + ':00',
'arriveDatetime': this.carItem.schoolDay + ' ' + this.carItem.schoolTime + ':00',
'arriveStation': this.siteCueent,
'arriveNumber': this.carItem.personNumber,
'isPicked': this.carItem.isTransfer ? 1 : 0,
'isOntime': this.carItem.isOnTime ? 2 : 1
}
this.$api.post('/wayToSchool/handle', params,
r => {
this.$vux.loading.hide()
setTimeout(() => {
this.$router.push({name: 'itemResult'})
}, 300)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
popupDate (obj) {
if (this.dateShow) {
this.dateShow = false
} else {
this.dateShow = true
}
this.isTimes = obj
if (obj === 'station') {
this.selectTime.startDate = ''
this.selectTime.endDate = this.carItem.schoolDay
} else if (obj === 'school') {
this.selectTime.startDate = this.carItem.stationDay
this.selectTime.endDate = ''
}
},
onRight (obj) {
if (obj === 'station') {
this.carItem.stationDay = this.selectTime.date
this.carItem.stationTime = this.selectTime.time
} else if (obj === 'school') {
this.carItem.schoolDay = this.selectTime.date
this.carItem.schoolTime = this.selectTime.time
}
if (this.selectTime.date !== '') {
this.dateShow = false
} else {
this.$vux.toast.text('请选择日期', 'middle')
}
if (timestamp(this.endDate) < timestamp(this.carItem.stationDay) || timestamp(this.endDate) < timestamp(this.carItem.schoolDay)) {
this.carItem.isTransfer = false
this.carItem.isOnTime = true
this.sureToLeave = true
} else {
this.carItem.isTransfer = false
this.carItem.isOnTime = false
this.sureToLeave = false
}
},
onLeft () {
this.dateShow = false
},
/* Time */
handleScrollTime (vertical, horizontal, nativeEvent) {
let hour = Math.floor((horizontal.scrollLeft / 30) * 0.5)
let min = Math.round(((horizontal.scrollLeft / 30 * 0.5) - hour) * 60)
this.selectTime.time = numberPad(hour) + ':' + numberPad(min)
},
changeChecker (itemValue, itemDisabled) {
this.sites.forEach(element => {
if (element.arriveStation === itemValue) {
this.companion = element.companion
}
})
},

cancelEdit () {
setTimeout(() => {
this.$router.push({name: 'itemResult'})
}, 300)
},

changeDate () {
if (this.isTimes === 'station') {
if (timestamp(this.endDate) < timestamp(this.selectTime.date)) {
this.showConfirm = true
} else {
this.sureToLeave = false
}
} else if (this.isTimes === 'school') {
if (timestamp(this.endDate) < timestamp(this.selectTime.date)) {
this.showConfirm = true
} else {
this.sureToLeave = false
}
}
},

onConfirm () {
this.sureToLeave = true
},
onCancel () {
this.selectTime.date = ''
},

getCarList () {
let params = {
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId
}
this.$api.get('/configWayToSchool', params,
r => {
if (this.type !== '4') {
this.sites = r.data.filter(item => {
if (item.transportation === this.type) {
return true
}
})
}
this.getLastData()
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
getLastData () {
let params = {
'studentId': this.studentId
}
this.$api.get('/wayToSchool', params,
r => {
if (r.data.length > 0) {
this.btnSavetext = '重新办理'
this.id = r.data[0].id
this.datamanagementId = r.data[0].datamanagementId
this.carItem.stationDay = r.data[0].departureDatetime.split(' ')[0]
this.carItem.stationTime = r.data[0].departureDatetime.split(' ')[1].substring(0, 5)
this.carItem.schoolDay = r.data[0].arriveDatetime.split(' ')[0]
this.carItem.schoolTime = r.data[0].arriveDatetime.split(' ')[1].substring(0, 5)
this.carItem.isTransfer = r.data[0].isPicked === 1
this.carItem.personNumber = r.data[0].arriveNumber
this.carItem.isOnTime = r.data[0].isOntime !== 1
if (r.data[0].transportation === this.type) {
this.siteCueent = r.data[0].arriveStation
}
this.sites.forEach(element => {
if (element.arriveStation === r.data[0].arriveStation) {
this.companion = element.companion
}
})
if (timestamp(this.endDate) < timestamp(this.carItem.stationDay) || timestamp(this.endDate) < timestamp(this.carItem.schoolDay)) {
this.sureToLeave = true
} else {
this.sureToLeave = false
}
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/car/carInfo.vue